module.exports = __webpack_public_path__ + "img/envelope8.58f8421f.jpg";